import { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";
import { loginApi, meApi } from "@/lib/api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null=loading, false=anon, {username}=auth
  const [error, setError] = useState("");

  useEffect(() => {
    if (!localStorage.getItem("hs_token")) {
      setUser(false);
      return;
    }
    meApi()
      .then((u) => setUser(u))
      .catch(() => {
        localStorage.removeItem("hs_token");
        setUser(false);
      });
  }, []);

  const login = useCallback(async (username, password) => {
    setError("");
    try {
      const r = await loginApi(username.trim().toLowerCase(), password);
      localStorage.setItem("hs_token", r.token);
      setUser({ username: r.username });
      return true;
    } catch (e) {
      const d = e.response?.data?.detail;
      setError(typeof d === "string" ? d : "Feil ved pålogging");
      return false;
    }
  }, []);

  const logout = useCallback(() => {
    localStorage.removeItem("hs_token");
    setUser(false);
  }, []);

  const value = useMemo(
    () => ({ user, error, login, logout }),
    [user, error, login, logout]
  );

  return <AuthCtx.Provider value={value}>{children}</AuthCtx.Provider>;
}

export const useAuth = () => useContext(AuthCtx);
